/**
 * Known error codes that are common across all domains.
 */
export var CommonErrorCodes;
(function (CommonErrorCodes) {
    /**
     * UnknownError
     */
    CommonErrorCodes[CommonErrorCodes["UnknownError"] = 10000] = "UnknownError";
    /**
     * The state of the response is invalid
     */
    CommonErrorCodes[CommonErrorCodes["InvalidState"] = 10002] = "InvalidState";
    /**
     * A provided value was invalid
     */
    CommonErrorCodes[CommonErrorCodes["InvalidArgument"] = 10003] = "InvalidArgument";
})(CommonErrorCodes || (CommonErrorCodes = {}));
//# sourceMappingURL=common-error-codes.js.map